import type { Customer, Company } from 'types'

export const getOwner = (customer: Customer, company: Company) => {
  if (!customer) {
    return {
      id: company.id,
      title: company.name,
      image: company.logo,
      type: 'company',
    }
  }

  if (customer.first_name && customer.last_name) {
    return {
      id: customer.id,
      title: `${customer.first_name} ${customer.last_name}`,
      image: customer.avatar === null ? '' : customer.avatar,
      type: 'customer',
    }
  }

  return {
    id: customer.id,
    title: customer.email,
    image: '',
    type: 'customer',
  }
}

export const getNameOrEmailSlug = (
  item: { first_name: string | null; last_name: string | null; email: string } | undefined
) => {
  if (!item) return null

  if (item?.first_name === null) {
    return item.email.split('@')[0]
  }

  return `${item?.first_name} ${item?.last_name}`
}

export const getErrorMessage = (error: any) => {
  let message = 'Something went wrong. Please try again.'

  if (error === null || error === undefined || error === '' || !error.hasOwnProperty('message')) {
    return message
  }

  if (typeof error === 'string') {
    message = error
    return message
  }

  if (typeof error.message === 'string') {
    message = error.message
    return message
  }

  if (typeof error.message === 'object') {
    message = error.message[0]
    return message
  }

  if (typeof error.message[0] === 'object') {
    message = error.message[0][0]
    return message
  }

  return message
}

export const getContrastColor = (color: string) => {
  const rgb = parseInt(color.slice(1), 16)
  const r = (rgb >> 16) & 0xff
  const g = (rgb >> 8) & 0xff
  const b = (rgb >> 0) & 0xff
  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

  return luma < 128 ? '#fff' : '#000'
}

/*
 * Parses Shopify global id
 * @param gid - Shopify global id
 * @returns - Shopify id
 * @example
 * parseShopifyGid('gid://shopify/Product/1234567890') => '1234567890'
 */
export const parseShopifyGid = (gid: string): string => {
  const match = gid.match(/\/(\d+)$/)
  return match ? match[1] : ''
}

export const toDollar = (amount: number, noDecimals = false) => {
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'usd',
    minimumFractionDigits: noDecimals ? 0: 2,
    maximumFractionDigits: noDecimals ? 0: 2,
  })
}
